import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/sign-out.svg';
import { Icon } from '../Icon/Icon';
export const SignOutIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
